var DepositFixForm = {

        host: "https://app.depositfix.com/",
        cssFile: "",
        s3Host: "https://depositfix.s3.amazonaws.com/",
        hubSpotFormId: "",
        userId: "",
        amount: "",
        originalAmount: "",
        discountAmount: 0,
        discountPercent: 0,
        discountObject: {},
        finalAmount: 0,
        productName: "",
        subscriptionPlan: "",
        dynamicPlan: false,
        portalId: "",
        stripePubKey: "",
        stripePaymentMethod: "",
        hubspotForm: {},
        hubspotFormObj: {},
        discount: false,
        stripeDiscount: false,
        discountId: "",
        stripeCouponId: "",
        currency: "USD",
        currencySign: "$",
        termsUrl: "",
        submitBtnText: "Buy Now",
        mode: "",
        stripeAPI: {},
        stripeElement: {},
        stripeElementStyles: {},
        hsContext: {},
        followUpEmailId: "",
        followUpEmailCampaignId: "",
        formContext: {},
        products: {},
        showQuantity: false,
        quantity: 0,
        redirectUrl: "",
        fallbackRedirectUrl: "https://help.depositfix.com/article/14-setup-redirect-after-payment",
        lambdaUrl: "https://9j11ty5tq3.execute-api.us-east-1.amazonaws.com/prod",
        loggerUrl: "https://woetzkq6v6.execute-api.us-east-1.amazonaws.com/prod",
        paymentType: "",
        tax: "",
        invoiceFooter: "",
        callback: function () {
        },
        beforeSubmitCallback: function () {
        },
        currencySymbols: {
            'USD': '$', // US Dollar
            'EUR': '€', // Euro
            'SEK': 'kr', // Swedish Krona
            'CRC': '₡', // Costa Rican Colón
            'GBP': '£', // British Pound Sterling
            'ILS': '₪', // Israeli New Sheqel
            'INR': '₹', // Indian Rupee
            'JPY': '¥', // Japanese Yen
            'KRW': '₩', // South Korean Won
            'NGN': '₦', // Nigerian Naira
            'PHP': '₱', // Philippine Peso
            'PLN': 'zł', // Polish Zloty
            'PYG': '₲', // Paraguayan Guarani
            'THB': '฿', // Thai Baht
            'UAH': '₴', // Ukrainian Hryvnia
            'VND': '₫', // Vietnamese Dong
            'RUB': '₽', // Russian Ruble
            'AUD': 'AUD ', // Australian
            'CAD': 'CAD ', // Canadian,
            'NZD': 'NZD ', // New Zealand
            'CHF': 'CHF ', // Swiss
            'SGD': 'S$' // Singapore

        },


        init: function (params) {
            // no need to change props manually
            if (location.host === 'depositfix-form') {
                DepositFixForm.host = 'https://test.depositfix.com/';
            }

            if (location.protocol !== 'https:') {
                alert("Stripe requires payment page to be loaded with https. How to setup SSL with HubSpot: https://knowledge.hubspot.com/website-user-guide/how-to-set-up-ssl-for-a-hubspot-website");
                return false;
            }

            if (params.cssFile !== undefined || params.cssFile === null) {
                DepositFixForm.cssFile = params.cssFile;
            } else {
                DepositFixForm.cssFile = DepositFixForm.s3Host + "depositfix.css";
            }

            DepositFixForm.hubSpotFormId = params.hubSpotFormId;
            DepositFixForm.userId = params.userId;

            DepositFixForm.productName = params.productName;
            DepositFixForm.subscriptionPlan = params.subscriptionPlan;
            DepositFixForm.dynamicPlan = params.dynamicPlan;
            DepositFixForm.termsUrl = params.termsUrl;
            DepositFixForm.mode = params.mode;

            if (params.discount) {
                DepositFixForm.discount = params.discount;
            }

            if (params.stripeDiscount) {
                DepositFixForm.stripeDiscount = params.stripeDiscount;
            }

            if (params.portalId) {
                DepositFixForm.portalId = params.portalId;
            }

            if (params.currency
                && DepositFixForm.currencySymbols[DepositFixForm.currency.toUpperCase()]) {
                DepositFixForm.currency = params.currency;
                DepositFixForm.currencySign = DepositFixForm.currencySymbols[DepositFixForm.currency.toUpperCase()];
            }

            DepositFixForm.amount = DepositFixForm.cleanAmount(params.amount);
            DepositFixForm.originalAmount = DepositFixForm.amount;
            DepositFixForm.redirectUrl = params.redirectUrl;

            //Legacy support
            if (DepositFixForm.subscriptionPlan && DepositFixForm.subscriptionPlan
                == "df_dynamic") {
                DepositFixForm.dynamicPlan = true;
            }

            if (!DepositFixForm.subscriptionPlan && DepositFixForm.dynamicPlan) {
                DepositFixForm.subscriptionPlan = "df_dynamic";
            }

            if (params.callback) {
                DepositFixForm.callback = params.callback;
            }

            if (params.beforeSubmitCallback) {
                DepositFixForm.beforeSubmitCallback = params.beforeSubmitCallback;
            }

            if (params.stripeElementStyles) {
                DepositFixForm.stripeElementStyles = params.stripeElementStyles;
            } else {
                DepositFixForm.stripeElementStyles = {base: {fontSize: '18px'}}
            }

            if (params.followUpEmailId) {
                DepositFixForm.followUpEmailId = params.followUpEmailId;
            }

            if (params.followUpEmailCampaignId) {
                DepositFixForm.followUpEmailCampaignId = params.followUpEmailCampaignId;
            }

            if(params.products){
                DepositFixForm.products = params.products;
            }

            if(params.subscriptions){
                DepositFixForm.subscriptions = params.subscriptions;
            }

            if(params.showQuantity){
                DepositFixForm.showQuantity = params.showQuantity;
            }

            if(params.paymentType){
                DepositFixForm.paymentType = params.paymentType;
            }

            if(params.tax){
                DepositFixForm.tax = params.tax;
            }

            if(params.billingDate){
                DepositFixForm.billingDate = params.billingDate;
            }

            if(params.trialDays){
                DepositFixForm.trialDays = params.trialDays;
            }

            DepositFixForm.loadAllCss(DepositFixForm.cssFile);

            DepositFixForm.loadJS(
                "https://code.jquery.com/jquery-3.4.1.min.js",
                DepositFixForm.loadScripts);
        },

        getAmountParameterFromUrl: function () {
            return DepositFixForm.getParameterFromUrl('amount');
        },

        getParameterFromUrl: function (param) {
            var qs = (function (a) {
                if (a == "") {
                    return {};
                }
                var b = {};
                for (var i = 0; i < a.length; ++i) {
                    var p = a[i].split('=', 2);
                    if (p.length == 1) {
                        b[p[0]] = "";
                    } else {
                        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
                    }
                }
                return b;
            })(window.location.search.substr(1).split('&'));
            return qs[param];
        },

        loadScripts: function () {
            //$ = jQuery.noConflict(true);
            $.when(
                jQuery.getScript("https://cdn.depositfix.com/js/hs-form-v2.js"),
                //$.getScript("https://ajax.aspnetcdn.com/ajax/jquery.validate/1.14.0/jquery.validate.min.js"),
                $.getScript("https://js.stripe.com/v3/"),
                $.Deferred(function (deferred) {
                    $(deferred.resolve);
                })
            ).done(function () {
                $("#df-script").after("<div id='df-card-container'></div>");
                DepositFixForm.initUserSettings();
            });
        },

        initUserSettings: function () {

            var url = DepositFixForm.url.getStripeDetails();

            if (DepositFixForm.mode) {
                url += "&mode=" + DepositFixForm.mode;
            }

            $.get(url, function (data) {
                if (data.status == "Expired" || data.status == "Cancelled") {
                    var errorMessage = "DepositFix account is expired";
                    var html = "<div class='df-title'>" + errorMessage + "</div>";
                    $("#df-card-container").prepend(html);
                    return;
                }
                DepositFixForm.portalId = data.portalId;
                DepositFixForm.stripePubKey = data.stripePublicKey;

                DepositFixForm.initHubSpotForm();
            }).fail(function (result) {
                var errorMessage = "Something went wrong, please reload the page.";
                if (result.responseJSON) {
                    errorMessage = result.responseJSON.errorMessage;
                }
                var html = "<div class='df-title'>" + errorMessage + "</div>";
                $("#df-card-container").prepend(html);
                DFUtils.logMessage("cannon get initUserSettings " + url, result);
            });

            DFUtils.initGlobalLogger();

        },

        initTitles: function () {
            var html = "<div class='df-title'>" + DepositFixForm.productName + "</div>";

            $("#df-card-container").prepend(html);
        },

        initHubSpotForm: function () {

            var hubspotParams = {
                portalId: DepositFixForm.portalId,
                formId: DepositFixForm.hubSpotFormId,
                target: "#df-card-container",
                css: '',
                onFormReady: function ($form) {
                    DepositFixForm.hubspotForm = $form;
                    DepositFixForm.initStripeForm($("#df-card-container"));
                    DepositFixForm.initTitles();

                    DepositFixForm.submitBtnText = $form.find(
                        ".hs_submit .hs-button").val();
                    $form.find(".hs_submit").hide();
                    $("#df_buybtn").val(DepositFixForm.submitBtnText);

                    DepositFixForm.postInit();
                },
                onFormSubmit: function ($form) {
                    return false;
                }
            };

            DepositFixForm.hubspotFormObj = hbspt.forms.create(hubspotParams);
        },

        postInit: function(){

            DepositFixForm.callback();
            //Customer specific js
            DFUtils.loadJS(
                DepositFixForm.lambdaUrl + '/js?form=' + DepositFixForm.hubSpotFormId);

            DepositFixForm.loadContext();
            DepositFixForm.setupRedirectUrl();
            DFAnalytics.trackPage();
        },

        initStripeForm: function (container) {

            var amountFromUrl = DepositFixForm.getAmountParameterFromUrl();

            var stripeFormCode = "<form class='hs-form stacked' id='df_stripe_form' action='' method='POST'>";
            if (!DepositFixForm.amount) {
                var defaultAmount = '';
                if (amountFromUrl) {
                    defaultAmount = amountFromUrl;
                    DepositFixForm.amount = amountFromUrl;
                }

                if (DepositFixForm.dynamicPlan) {
                    stripeFormCode += DFTemplate.dynamicPlan(defaultAmount);
                } else {
                    stripeFormCode += DFTemplate.dynamicAmount(defaultAmount);
                }

            } else if (amountFromUrl) {
                DepositFixForm.amount = amountFromUrl;
            }

            if(DepositFixForm.products && DepositFixForm.products.length > 0){
                stripeFormCode += DFTemplate.multipleProducts(DepositFixForm.products);
            }

            if(DepositFixForm.subscriptions && DepositFixForm.subscriptions.length > 0){
                stripeFormCode += DFTemplate.multipleSubscriptions(DepositFixForm.subscriptions);
            }

            if (DepositFixForm.showQuantity) {
                stripeFormCode += DFTemplate.quantity();
            }

            stripeFormCode += DFTemplate.creditCard();
            stripeFormCode += DFTemplate.discountCode();

            if (DepositFixForm.termsUrl) {
                stripeFormCode += DFTemplate.termsConditions();
            }

            var totalAmount;
            if (DepositFixForm.amount) {
                totalAmount = DepositFixForm.formatMoney(DepositFixForm.amount);
            } else {
                totalAmount = DepositFixForm.currencySign + 0;
            }

            stripeFormCode += DFTemplate.formFooter(totalAmount);

            var stripeForm = $(stripeFormCode);
            container.append(stripeForm);


            //Init Stripe
            DepositFixForm.stripeAPI = Stripe(DepositFixForm.stripePubKey);
            var elements = DepositFixForm.stripeAPI.elements();
            DepositFixForm.stripeElement = elements.create('card', {
                hidePostalCode: true,
                style: DepositFixForm.stripeElementStyles
            });
            DepositFixForm.stripeElement.mount('#stripe_elements');

                $("#amount").focusout(function () {
                DepositFixForm.evaluateTotalAmount();
            });

            DFTemplate.initListeners();

            if (DepositFixForm.discount) {
                $(".df-discount-area").show();
                DepositFixForm.attachDiscountChecker();
                DepositFixForm.applyCouponFromUrl(DepositFixForm.getParameterFromUrl("discount"));
            } else if (DepositFixForm.stripeDiscount) {
                $(".df-discount-area").show();
                DepositFixForm.attachStripeCouponChecker();
                DepositFixForm.applyCouponFromUrl(DepositFixForm.getParameterFromUrl("discount"));
            }

            //DepositFixForm.attachStripeValidator();

            $("#df_stripe_form").submit(function (e) {

                DepositFixForm.beforeSubmitCallback();
                DepositFixForm.startProgress();
                DepositFixForm.globalSubmit(e);

                e.stopPropagation();
                return false;
            });
        },

        // discountMode can be: stripe, df, or ''
        setDiscountModeAmountAndPlan: function (discountMode, amount, subscriptionPlan) {

            DepositFixForm.setAmount(amount);
            DepositFixForm.subscriptionPlan = subscriptionPlan;
            DepositFixForm.clearDiscountInfo();

            switch (discountMode) {
                case 'df':
                case 'depositfix':
                    DepositFixForm.discount = true;
                    DepositFixForm.stripeDiscount = false;
                    $("#apply-discount-btn").off('click');
                    DepositFixForm.attachDiscountChecker();
                    $(".df-discount-area").show();
                    break;
                case 'stripe':
                    DepositFixForm.discount = false;
                    DepositFixForm.stripeDiscount = true;
                    $("#apply-discount-btn").off('click');
                    DepositFixForm.attachStripeCouponChecker();
                    $(".df-discount-area").show();
                    break;
                case false:
                case '':
                default:
                    $(".df-discount-area").hide();
                    $("#apply-discount-btn").off('click');
                    DepositFixForm.discount = false;
                    DepositFixForm.stripeDiscount = false;
            }
        },

        hidePaymentFields: function(){
            $('.df-payment-field').hide();
        },

        showPaymentFields: function(){
            $('.df-payment-field').show();
        },

        attachDiscountChecker: function () {
          $("#apply-discount-btn").click(function () {
            DepositFixForm.clearDiscountInfo();
            var code = $("#df-discount-code").val();
            if (code) {
              var url = DepositFixForm.url.getDiscount() + "&code=" + code;
              $.get(url)
                  .done(function (result) {
                    // hide cc field if 100 percent discount, else, do opposite
                    if (result.percent === 100){
                      DepositFixForm.hidePaymentFields();
                      DepositFixForm.paymentType = 'NO_PAYMENT';
                    } else {
                      DepositFixForm.showPaymentFields();
                    }
                    DepositFixForm.discountObject = result;
                    DepositFixForm.discountObject.code = code;
                    DepositFixForm.applyDiscount(result);
                  }).fail(function (result) {
                    if(!DepositFixForm.couponId){
                        DepositFixForm.showPaymentFields();
                        $("#df-discount-result").text("Discount code not found");
                    }
              });
            }
            return false;
          });
        },

        attachStripeCouponChecker: function () {
            $("#apply-discount-btn").click(function () {
                DepositFixForm.clearDiscountInfo();
                var couponId = $("#df-discount-code").val();
                if (couponId) {
                    var url = DepositFixForm.url.getCoupon() + "&couponId=" + couponId;
                    $.get(url).done(function (result) {

                        DepositFixForm.discountObject = result;
                        DepositFixForm.applyStripeCoupon(result);

                    }).fail(function (result) {

                        if(!DepositFixForm.discountId){
                            DepositFixForm.showPaymentFields();

                            var errorMessage = "Discount code not found";
                            if (result.responseJSON) {
                                errorMessage = result.responseJSON.errorMessage;
                            }
                            $("#df-discount-result").text(errorMessage);

                        }
                    });
                }
                return false;
            });
        },

        applyCouponFromUrl: function(coupon){
            if(!coupon){
                return;
            }

            $("#df-discount-code").val(coupon)
            $("#apply-discount-btn").click();
        },

        clearDiscountInfo: function () {
            DepositFixForm.finalAmount = DepositFixForm.amount;
            DepositFixForm.discountAmount = 0;
            DepositFixForm.discountPercent = 0;
            DepositFixForm.discountId = "";
            DepositFixForm.stripeCouponId = "";

            $(".df-title").html(DepositFixForm.productName + " - "
                + DepositFixForm.formatMoney(DepositFixForm.finalAmount));
            $("#df-final-amount").html(DepositFixForm.formatMoney(
                DepositFixForm.finalAmount));
            $("#df-discount-result").html("");
        },

        // overcharge, never undercharge 84.0101 -> 84.02
        toTwoDec: function (num) {
            return Number(num + .0049).toFixed(2);
        },

        applyDiscount: function (discount) {
            if (discount.amount !== null) {
                DepositFixForm.discountAmount = discount.amount;
                DepositFixForm.finalAmount = Math.max(0, DepositFixForm.toTwoDec(DepositFixForm.amount
                    - DepositFixForm.discountAmount));
            }
            else {
                // compute still because it's shown in the title
                DepositFixForm.discountPercent = discount.percent;
                DepositFixForm.finalAmount = Math.max(0, DepositFixForm.toTwoDec(DepositFixForm.amount
                    - (DepositFixForm.amount * Number(DepositFixForm.discountPercent) * .01)));
            }

            DepositFixForm.discountId = discount.id;
            DepositFixForm.hidePaymentTotalDiscount();
            DepositFixForm.discountAppliedMessage();
        },

        applyStripeCoupon: function (coupon) {
            if (coupon.amountOff) {
                DepositFixForm.discountAmount = coupon.amountOff * 0.01;
                DepositFixForm.finalAmount = Math.max(0, DepositFixForm.amount
                    - DepositFixForm.discountAmount);
            } else if (coupon.percentOff) {
                DepositFixForm.discountPercent = coupon.percentOff;
                DepositFixForm.finalAmount = (DepositFixForm.amount
                    - DepositFixForm.amount * DepositFixForm.discountPercent
                    * 0.01).toFixed(2);
            }

            DepositFixForm.stripeCouponId = coupon.id;
            DepositFixForm.hidePaymentTotalDiscount();
            DepositFixForm.discountAppliedMessage();
        },

        hidePaymentTotalDiscount: function(){
            // hide cc field if 100 percent discount, else, do opposite
            if (DepositFixForm.finalAmount === 0 || DepositFixForm.discountPercent === 100) {
                DepositFixForm.hidePaymentFields();
                DepositFixForm.paymentType = 'NO_PAYMENT';
            }
            else {
                DepositFixForm.showPaymentFields();
                DepositFixForm.paymentType = '';
            }
        },

        discountAppliedMessage: function () {
            var html = DepositFixForm.productName + " - "
                + DepositFixForm.currencySign + DepositFixForm.finalAmount;
            if (DepositFixForm.discountAmount) {
                html = html + " (-"
                    + DepositFixForm.currencySign + DepositFixForm.discountAmount
                    + " discount)";

                $("#df-discount-result").html("Discount of "
                    + DepositFixForm.currencySign + DepositFixForm.discountAmount
                    + " applied.");
            } else if (DepositFixForm.discountPercent) {
                html = html + " (-"
                    + DepositFixForm.discountPercent + "%"
                    + " discount)";

                $("#df-discount-result").html("Discount of "
                    + DepositFixForm.discountPercent + "%"
                    + " applied.");
            }

            $(".df-title").html(html);
            $("#df-final-amount").html(DepositFixForm.formatMoney(
                DepositFixForm.finalAmount));
        },

        evaluateTotalAmount: function () {
            DepositFixForm.amount = DepositFixForm.cleanAmount($("#amount").val());

            if (DepositFixForm.discountAmount) {
                DepositFixForm.finalAmount = Math.max(0, DepositFixForm.amount
                    - DepositFixForm.discountAmount);
            } else {
                DepositFixForm.finalAmount = DepositFixForm.isAmount(
                    DepositFixForm.amount) ? DepositFixForm.amount : 0;
            }
            $("#df-final-amount").html(DepositFixForm.formatMoney(
                DepositFixForm.finalAmount));

            if (DepositFixForm.discountAmount) {
                var html = DepositFixForm.productName + " - "
                    + DepositFixForm.formatMoney(DepositFixForm.finalAmount) + " (-"
                    + DepositFixForm.formatMoney(DepositFixForm.discountAmount) + " discount)";
            } else {
                var html = DepositFixForm.productName + " - "
                    + DepositFixForm.formatMoney(DepositFixForm.finalAmount);
            }

            $(".df-title").html(html);
            $("#df-final-amount").html(DepositFixForm.formatMoney(
                DepositFixForm.finalAmount));

        },

        valid: function(callback){
            var isFormValid = true;
            if (hubspot){
                //var form = hubspot.form.api.getFormForEl(document.getElementById('hsForm_' + DepositFixForm.hubSpotFormId));

                var hsForm = DepositFixForm.hubspotForm[0] || document.getElementById('hsForm_' + DepositFixForm.hubSpotFormId);

                var form = hubspot.form.api.getFormForEl(hsForm);
                if  (form) {
                    var formComponent = form._getComponent();
                    try{
                        formComponent.validateForm()
                            .then(function (validationResults) {
                                for (var i = 0; i < validationResults.length; i++) {
                                    if  (validationResults[i].valid === false){
                                        isFormValid = false;
                                        break
                                    }
                                }
                                callback(isFormValid);
                                return validationResults
                            })
                            .then(function (validationRes) {
                                console.log(validationRes);
                                return validationRes.reduce(function(accumulator, current){
                                    accumulator[current.name] = {
                                        valid: current.valid,
                                        errors: current.messages,
                                        errorTypes: current.errorTypes
                                    };
                                    return accumulator;
                                }, {});
                            })
                            .then(function (formValidity){
                                console.log(formValidity);
                                try{
                                    formComponent.setState({
                                        formValidity : formValidity
                                    })
                                }catch (error) {
                                    console.log(error);
                                    var styleTag = $('<style>#df-card-container .input > label.error { display: block !important; }</style>')
                                    $('html > head').append(styleTag);
                                }
                            });
                    }
                    catch (error) {
                        console.log(error);
                        var styleTag = $('<style>#df-card-container .input > label.error { display: block !important; }</style>')
                        $('html > head').append(styleTag);
                    }
                }
            }
            return isFormValid
        },

        globalSubmit: function (e) {

            DepositFixForm.startProgress();
            DepositFixForm.valid(function(valid){

                if(valid && document.getElementById('df_stripe_form').checkValidity()){

                    if(DepositFixForm.paymentType == "NO_PAYMENT"){
                        DepositFixForm.submitDepositFix();
                    }else{
                        DepositFixForm.submitStripeForm();
                    }
                }else{
                    DepositFixForm.stopProgress();
                }
            });
        },

        submitStripeForm: function (e) {

            var name = DepositFixForm.getElement("firstname");

            if(DepositFixForm.getElement("lastname")){
                name += ' ' + DepositFixForm.getElement("lastname");
            }

            var line1 = DepositFixForm.getElement("address");
            var city = DepositFixForm.getElement("city");
            var postalCode = DepositFixForm.getElement("zip");
            var state = DepositFixForm.getElement("state");
            var country = DepositFixForm.getElement("country");
            
            var cartData = {
                billing_details: {
                    name: name ? name : null,
                    address: {
                        line1: line1 ? line1 : null,
                        line2: null,
                        city: city ? city : null,
                        postal_code: postalCode ? postalCode : null,
                        state:  state ? state : null,
                        // TODO: Ignore country for now, later do mapping to ISO 3166-2 format since Stripe requires it.
                        // country: country ? mapToStripeCountryFormat(country) : null
                        country: null
                    }
                }
            };

            DepositFixForm.stripeAPI
                .createPaymentMethod('card', DepositFixForm.stripeElement, cartData)
                .then(DepositFixForm.stripeResponseHandler);
        },

        attachStripeValidator: function () {

            if (DepositFixForm.termsUrl) {
                $(".terms_chbx").rules("add", {
                    required: true,
                    messages: {
                        required: "Please accept terms and conditions"
                    },
                });
            }
        },

        stripeResponseHandler: function (response) {

            DepositFixForm.hideError();

            if (!response.error) {

                DepositFixForm.stripePaymentMethod = response.paymentMethod.id;
                DepositFixForm.submitDepositFix();
            } else {
                DepositFixForm.showError(response.error.message);
                DFUtils.logMessage("Stripe Error", response);
            }
        },

        submitDepositFix: function () {

            var url = DepositFixForm.url.getDepositFixSubmit();

            var data = {
                "productName": DepositFixForm.productName,
                "subscriptionPlan": DepositFixForm.subscriptionPlan,
                "stripeEmail": DepositFixForm.hubspotForm.find(
                    "input[name=email]").val(),
                "paymentMethodId": DepositFixForm.stripePaymentMethod,
                "currency": DepositFixForm.currency,
                "mode": DepositFixForm.mode,
                "hscontext": JSON.stringify(DepositFixForm.hsContext),
                "hsFormId": DepositFixForm.hubSpotFormId,
                "paymentType": DepositFixForm.paymentType,
                "allParams": [{}], //is array for ability to submit multiple contacts
                "files": []
            };

            if (DepositFixForm.amount) {
                data["amount"] = DepositFixForm.amount;
            } else {
                data["amount"] = $("input[name=amount]").val();
            }

            if(DepositFixForm.tax){
                data["tax"] = DepositFixForm.tax;
            }

            if(DepositFixForm.invoiceFooter){
                data["invoice_footer"] = DepositFixForm.invoiceFooter;
            }

            if (DepositFixForm.dynamicPlan) {
                data["dynamicPlanInterval"] = $("#dynamic-plan-interval").val();
            }

            if (DepositFixForm.skipStripeEmail) {
                data['params[skip_stripe_email]'] = true;
            }

            if (DepositFixForm.billingDate) {

                var bilingDate = Date.parse(DepositFixForm.billingDate + " 00:00");
                var today = new Date().getTime();

                var trialDays = Math.max(0,
                    Math.ceil(
                        (bilingDate - today)/(60*60*24*1000)));

                data['trialDays'] = trialDays;
            }


            if (DepositFixForm.trialDays) {
                data['trialDays'] = DepositFixForm.trialDays;
            }

            data["amount"] = ("" + data["amount"]).replace(/,/g, '');

            var form = DepositFixForm.hubspotForm;
            var formInputsArray = form.serializeArray();

            if(DepositFixForm.showQuantity){
                formInputsArray.push({"name": "df_quantity", "value": $("#df_quantity").val()});
                data["quantity"] = $("#df_quantity").val();
            }

            if(DepositFixForm.quantity > 0){
                data["quantity"] = DepositFixForm.quantity;
            }

            //var formInputsArray = DepositFixForm.form.serializeArray();
            $.each(formInputsArray, function(i, field) {

                if(data["allParams"][0][field.name]){
                    if(!(data["allParams"][0][field.name] instanceof Array)){
                        var temp = data["allParams"][0][field.name];
                        data["allParams"][0][field.name] = [temp];
                    }

                    data["allParams"][0][field.name].push(field.value);
                }else{
                    data["allParams"][0][field.name] = field.value;
                }
            });


            if (DepositFixForm.discountId) {
                data["discountId"] = DepositFixForm.discountId;
                data["allParams"][0]["df_discount"] = DepositFixForm.discountObject.code;
            }
            if (DepositFixForm.stripeCouponId) {
                data["couponId"] = DepositFixForm.stripeCouponId;
                data["allParams"][0]["df_discount"] = DepositFixForm.stripeCouponId;
            }

            DepositFixForm.hideError();

            if (!DepositFixForm.doesFormContainFileFields(form[0])) {
                DepositFixForm.submitForm(url, data);
            } else {
                DepositFixForm.convertAllFilesToBytesAndSubmitForm(form[0], url, data);
            }

        },

        doesFormContainFileFields: function(fields) {
            for (var i = 0; i < fields.length; i++) {
                if (fields[i].type == 'file' && fields[i].files[0]) {
                    return true;
                }
            }
            return false;
        },

        convertAllFilesToBytesAndSubmitForm: function(form, url, data) {
            var promises = [];
            $.each(form, function(i, field) {
                if (field.type == 'file' && field.files[0]) {
                    promises.push(DepositFixForm.convertFileToBytes(data, field));
                }
            });
            Promise.all(promises).then(function() {
                DepositFixForm.submitForm(url, data);
            });
        },

        convertFileToBytes: function(data, field) {

            return new Promise(function(resolve, reject) {
                var fileReader = new FileReader();
                var file = field.files[0];
                fileReader.onloadend = function() {
                    var fileObject = {
                        fieldName: field.name,
                        fileName: file.name,
                        bytes: btoa(fileReader.result)
                    };
                    data["files"].push(fileObject);
                    resolve();
                };
                fileReader.readAsBinaryString(file);
            });
        },

        submitForm: function(url, data) {
            DFUtils.logMessage("Submitting the form", data);
            $.ajax({
                type: "POST",
                url: url,
                data: JSON.stringify(data),
                dataType: "json",
                contentType: "application/json; charset=utf-8",

                success: function (response) {
                    if (response.stripe.requiresAction) {
                        DepositFixForm.handleCardAction(url, data, response.stripe.paymentIntentClientSecret);
                        return;
                    }
                    DepositFixForm.afterSubmit();
                }, error: function (response) {
                    var errorMessage = "Something went wrong, please try to reload the page";
                    if (response.responseJSON && response.responseJSON.errorMessage) {
                        errorMessage = response.responseJSON.errorMessage;
                    }
                    DepositFixForm.showError(errorMessage);
                    DFUtils.logMessage("Submit to DepositFix error", response);
                }
            });
        },

        handleCardAction: function(url, data, paymentIntentClientSecret) {
            DepositFixForm.stripeAPI
                .handleCardAction(paymentIntentClientSecret)
                .then(function(response) {
                    if (response.error) {
                        DepositFixForm.showError(response.error.message);
                        DFUtils.logMessage("Stripe Error", response);
                        return;
                    }
                    data["paymentIntentId"] = response.paymentIntent.id;
                    DepositFixForm.submitForm(url, data);
                });
        },

        afterSubmit: function(){
            top.location = DepositFixForm.redirectUrl;
        },

        setupRedirectUrl: function(){

            if(DepositFixForm.redirectUrl){
                return;
            }

            if(DepositFixForm.formContext.redirectUrl){
                DepositFixForm.redirectUrl = DepositFixForm.formContext.redirectUrl;
                return;
            }

            DepositFixForm.redirectUrl = DepositFixForm.fallbackRedirectUrl;
        },

        hideError: function () {
            $("#stripe_error").text("");
            $("#stripe_error").hide();
        },

        showError: function (errorMessage) {
            $("#stripe_error").text(errorMessage);
            $("#stripe_error").show();
            DepositFixForm.stopProgress();
        },

        startProgress: function () {
            $("div#dfLoader").addClass("show");
            $("#df_buybtn")
                .prop("value", "Processing...")
                .prop("disabled", "disable");
        },

        stopProgress: function () {
            $("div#dfLoader").removeClass("show");
            $("#df_buybtn")
                .prop("value", DepositFixForm.submitBtnText)
                .removeAttr("disabled");
        },

        loadAllCss: function(cssFile){

            DFUtils.loadCSS(cssFile);
            DFUtils.loadCSS(DepositFixForm.lambdaUrl + '/css?form=' + DepositFixForm.hubSpotFormId);
        },

        loadJS: function (src, callback) {

            var script = document.createElement('script'), loaded;
            script.setAttribute('src', src);
            document.getElementsByTagName('head')[0].appendChild(script);

            if (callback) {
                script.onreadystatechange = script.onload = function () {
                    if (!loaded) {
                        callback();
                    }

                    loaded = true;
                };
            }
        },

        getElement: function (name) {
            var hsForm = DepositFixForm.hubspotForm || document.getElementById('hsForm_' + DepositFixForm.hubSpotFormId)
            var elem = hsForm.find("[name=" + name + "]");
            if(elem.length != 0 && elem.val()){
                return elem.val();
            }

            return "";
        },

        loadContext: function () {

            DepositFixForm.formContext = JSON.parse(
                DepositFixForm.hubspotForm.find("[name='hs_context']").val());

            DepositFixForm.hsContext.pageUrl = document.URL;
            DepositFixForm.hsContext.pageName = $("title").text();
            DepositFixForm.hsContext.pageId = DepositFixForm.formContext.pageId;

            if(DepositFixForm.formContext.disableCookieSubmission){
                DepositFixForm.hsContext.hutk = '';
            }else{
                DepositFixForm.hsContext.hutk = DFUtils.getCookie("hubspotutk");
            }

            if(DepositFixForm.followUpEmailId){
                DepositFixForm.hsContext.followUpEmailId = DepositFixForm.followUpEmailId;
            }

            if(DepositFixForm.followUpEmailCampaignId){
                DepositFixForm.hsContext.followUpEmailCampaignId = DepositFixForm.followUpEmailCampaignId;
            }

            $.getJSON("https://jsonip.com/", function (data) {
                DepositFixForm.hsContext['ipAddress'] = data.ip;
            });
        },

        isAmount: function (value) {
            var regex = /^[0-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;
            return regex.test(value);
        },

        setAmount: function (amount){
            DepositFixForm.amount = DepositFixForm.cleanAmount(amount);
            $(".df-final-amount").text(DepositFixForm.formatMoney(DepositFixForm.amount));
        },

        addParams: function (url, data) {
            if (!$.isEmptyObject(data)) {
                url += (url.indexOf('?') >= 0 ? '&' : '?') + $.param(data);
            }

            return url;
        },

        formatMoney: function (amount) {
            amount = Number(amount);
            var minimumFractionDigits = amount % 1 > 0 ? 2 : 0;

            return DepositFixForm.currencySign + amount.toLocaleString(undefined, {minimumFractionDigits: minimumFractionDigits});
        },

        cleanAmount: function (amount) {
            return ("" + amount).replace(/[^\d.-]/g, '');
        },

        url: {

            getStripeDetails: function(){

                if(DepositFixForm.portalId){ //v2
                    return DepositFixForm.host + "pub/v2/stripe_details/?portalId=" + DepositFixForm.portalId + "&userId=" + DepositFixForm.userId;;
                }else{ //v1
                    return DepositFixForm.host + "pub/stripe_details/?userId=" + DepositFixForm.userId;
                }
            },

            getDepositFixSubmit: function(){
                if(DepositFixForm.portalId){ //v2
                    return DepositFixForm.host + "payments/v2/stripe/" + DepositFixForm.portalId;
                }else{ //v1
                    return DepositFixForm.host + "payments/stripe/" + DepositFixForm.userId;
                }
            },

            getDiscount: function(){
                if(DepositFixForm.portalId){ //v2
                    return DepositFixForm.host + "pub/v2/discounts/?portalId=" + DepositFixForm.portalId;
                }else{ //v1
                    return DepositFixForm.host + "pub/discounts/?userId=" + DepositFixForm.userId;
                }
            },

            getCoupon: function() {
                if (DepositFixForm.portalId) { //v2
                    return DepositFixForm.host + "pub/v2/stripe/coupons?portalId=" + DepositFixForm.portalId;
                } else { //v1
                    return DepositFixForm.host + "pub/stripe/coupons?userId=" + DepositFixForm.userId;
                }
            }
        }
    };

var DFUtils = {

        loadJS: function (src, callback) {

            var script = document.createElement('script'), loaded = false;
            script.setAttribute('src', src);
            script.async = true;
            document.getElementsByTagName('head')[0].appendChild(script);

            if (callback) {
                script.onreadystatechange = script.onload = function() {
                    if (!loaded && (!this.readyState || this.readyState == 'complete')) {
                        loaded = true;
                        callback();
                    }
                };
            }
        },

        loadCSS: function (filename) {

            if (filename + "" == "false") {
                return;
            }

            var fileref = document.createElement("link");
            fileref.setAttribute("rel", "stylesheet");
            fileref.setAttribute("type", "text/css");
            fileref.setAttribute("href", filename);
            document.getElementsByTagName("head")[0].appendChild(fileref);
        },

        formatMoney: function (amount) {
            return DepositFixForm.currencySign + amount.toLocaleString();
        },

        startProgress: function () {
            $("div#dfLoader").addClass("show");
            $("#df_buybtn")
                .prop("value", "Processing...")
                .prop("disabled", "disable");
        },

        stopProgress: function () {
            $("div#dfLoader").removeClass("show");
            $("#df_buybtn")
                .prop("value", DepositFixForm.submitBtnText)
                .removeAttr("disabled");
        },

        hideError: function () {
            $("#df_error").text("");
            $("#df_error").hide();
        },

        showError: function (errorMessage) {
            $("#df_error").text(errorMessage);
            $("#df_error").show();
            DFUtils.stopProgress();
        },

        getCookie: function (name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
        },

        logMessage: function (message, obj) {

            var formattedMessage =  "[" + DepositFixForm.portalId + "] " +
                                    "[" + location.href + "] " +
                                    "[" + message + "] " +
                                     (obj ? "[" + JSON.stringify(obj)  + "]" : "");

            var json = {"level": "INFO", "message": formattedMessage};

            jQuery.ajax({
                url: DepositFixForm.loggerUrl,
                type: "POST",
                headers: {
                    "Content-Type": "text/plain; charset=utf-8",
                },
                data: JSON.stringify(json)
            });
        },

        initGlobalLogger: function(){
            $(document).ready(function(){
                window.onerror = function(message, url, lineNumber) {
                    DFUtils.logMessage(message);
                    return false;
                };
            });
        }
}

var DFAnalytics = {

    trackPage: function(){
        var url = DepositFixForm.host + "analytics/page";
        $.ajax({
            url: url,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(DepositFixForm.formContext)
        });
    }
}

var DFTemplate = {

    /**
     * @return {string}
     */
    dynamicPlan : function(defaultAmount){

        return "<fieldset class='form-columns-2 df-payment-field'>" +
            " <div class='field hs-form-field'>" +
            "   <label>" +
            "     <span>Amount (" + DepositFixForm.currencySign + ")</span>" +
            "     <span class='hs-form-required'>*</span>" +
            "   </label>" +
            "   <div class='input'>" +
            "     <input id='amount' name='amount' class='hs-input amount dpi-amount' type='text' size='4' autocomplete='off' required value='" + defaultAmount + "'/>" +
            "       </div>" +
            "   </div>" +
            " <div class='field hs-form-field'>" +
            "   <label>" +
            "     <span>Every</span>" +
            "   </label>" +
            "           <select id='dynamic-plan-interval' class='hs-input dynamic-plan-interval' >" +
            "               <option value='day'>Day</option>" +
            "               <option value='week'>Week</option>" +
            "               <option value='month' selected='selected'>Month</option>" +
            "               <option value='year'>Year</option>" +
            "           </select>" +
            "       </div>" +
            "   </fieldset>";
        },

    /**
     * @return {string}
     */
    dynamicAmount : function(defaultAmount){
        return "<fieldset class='form-columns-1 df-payment-field'>" +
            " <div class='field hs-form-field'>" +
            "   <label>" +
            "     <span>Amount (" + DepositFixForm.currencySign + ")</span>" +
            "     <span class='hs-form-required'>*</span>" +
            "   </label>" +
            "   <div class='input'>" +
            "     <input id='amount' name='amount' class='hs-input amount' type='text' size='20' autocomplete='off' required value='" + defaultAmount + "'/>" +
            "       </div>" +
            "   </div>" +
            "</fieldset>";
    },

    /**
     * @return {string}
     */
    creditCard : function(){
        return "<fieldset class='form-columns-1 df-payment-field'>" +
            " <div class='field hs-form-field'>" +
            "   <label>" +
            "     <span id='hs-card-number-label'>Credit Card Number</span><span class='hs-form-required'>*</span>" +
            "   </label>" +
            "   <div class='input' id='stripe_elements'>" +
            "   </div>" +
            " </div>" +
            "</fieldset>";
    },

    /**
     * @return {string}
     */
    discountCode : function(){
        return "<fieldset class='form-columns-2 df-discount-area' style='display: none'>" +
            " <div class='field hs-form-field'>" +
            "   <label>" +
            "     <span>Discount Code</span>" +
            "   </label>" +
            "   <div class='input'>" +
            "     <input type='text' id='df-discount-code' name='df-discount-code' class='hs-input' autocomplete='off'/>" +
            "   </div>" +
            " </div>" +
            " <div class='field hs-form-field'>" +
            "       <label>&nbsp;</label>" +
            "   <a href='#' id='apply-discount-btn'>Apply Discount</a>" +
            " </div>" +
            "</fieldset>" +
            "<div id='df-discount-result' style='display:block;'></div>";
    },

    /**
     * @return {string}
     */
    termsConditions : function(){
        return "<fieldset class='form-columns-1'>" +
            " <div class='field hs-form-field'>" +
            "   <div class='input'>" +
            "           <input type='checkbox' name='terms_chbx' class='terms_chbx' required='required'/>" +
            "     <span>I accept the <a href='" + DepositFixForm.termsUrl + "' target='_blank'>Terms and Conditions</a></span>" +
            "     </div>" +
            " </div>" +
            "</fieldset>";
    },

    /**
     * @return {string}
     */
    multipleProducts : function(products){

        var options = "";

        for (var i = 0; i < products.length; i++){
            var product = products[i];
            options += "<option value='" + product.amount + "'>" + product.name + "</option>"
        }

        var select =  "<fieldset class='form-columns-1'>" +
            " <div class='field hs-form-field'>" +
            "   <label>" +
            "     <span>Product</span>" +
            "     <span class='hs-form-required'>*</span>" +
            "   </label>" +
            "   <div>" +
            "           <select class='input hs-input' id='df_products'>" + options + "</select>" +
            "       </div>" +
            "   </div>" +
            "</fieldset>";

        DFTemplate.jsListeners.push(function(){
            $("#df_products").change(function(){
                DepositFixForm.productName = $(this).find(":selected").text();
                DepositFixForm.originalAmount = $(this).find(":selected").val();
                DepositFixForm.setAmount($(this).find(":selected").val());

                if(DepositFixForm.showQuantity){
                    $("#df_quantity").change();
                }

                if(Object.keys(DepositFixForm.discountObject).length !== 0){
                    DepositFixForm.applyDiscount(DepositFixForm.discountObject);
                }

            }).change();
        });

        return select;
    },

    multipleSubscriptions : function(subscriptions){

        var options = "";

        for (var i = 0; i < subscriptions.length; i++){
            var subscription = subscriptions[i];
            options += "<option value='" + subscription.id + "' data-amount='" + subscription.amount + "'>" + subscription.name + "</option>"
        }

        var select =  "<fieldset class='form-columns-1'>" +
            " <div class='field hs-form-field'>" +
            "   <label>" +
            "     <span>Subscription Plan</span>" +
            "     <span class='hs-form-required'>*</span>" +
            "   </label>" +
            "   <div>" +
            "           <select class='input hs-input' id='df_subscriptions'>" + options + "</select>" +
            "       </div>" +
            "   </div>" +
            "</fieldset>";

        DFTemplate.jsListeners.push(function(){
            $("#df_subscriptions").change(function(){
                DepositFixForm.originalAmount = $(this).find(":selected").val();
                DepositFixForm.setAmount($(this).find(":selected").data("amount"));
                DepositFixForm.subscriptionPlan = $(this).find(":selected").val();
                DepositFixForm.productName = $(this).find(":selected").text();

                if(DepositFixForm.showQuantity){
                    $("#df_quantity").change();
                }

            }).change();
        });

        return select;
    },

    quantity : function(){

        var template = "<fieldset class='form-columns-2 df-quantity-area'>" +
            " <div class='field hs-form-field'>" +
            "   <label>" +
            "     <span>Quantity</span>" +
            "   </label>" +
            "   <div class='input'>" +
            "     <input type='number' id='df_quantity' name='df_quantity' class='hs-input' autocomplete='off' step='1' min='1' value='1'/>" +
            "   </div>" +
            " </div>" +
            "</fieldset>";

        DFTemplate.jsListeners.push(function(){
            $("#df_quantity").change(function(){
                DepositFixForm.setAmount(DepositFixForm.originalAmount * $(this).val());
            }).change();
        });

        return template;
    },

    formFooter: function(totalAmount){
        return "<fieldset class='form-columns-1'><label class='error' id='stripe_error'></label></fieldset>" +
            "<div class='seals df-payment-field'><img src='https://depositfix.s3.amazonaws.com/seal.png' style='width: 300px' /></div>" +
            "<fieldset class='form-columns-1'>" +
            " <div class='hs_submit'>" +
            "   <div class='actions'>" +
            "           <div class='total-amount'>" +
            "               Total: <span id='df-final-amount' class='df-final-amount'>" + totalAmount + "</span>" +
            "         </div>" +
            "           <input type='submit' value='" + DepositFixForm.submitBtnText + "' class='hs-button primary large' id='df_buybtn' />" +
            "       </div>" +
            " </div>" +
            "</fieldset>" +
            "</form>" +
            "<div id='dfLoader'></div>" +
            "<div class='copyright'>" +
            "   <a href='https://www.depositfix.com/?ref=form'>by DepositFix</a>" +
            "</div>";
    },

    jsListeners: [],

    initListeners: function(){
        for (var i = 0; i < DFTemplate.jsListeners.length; i++) {
            DFTemplate.jsListeners[i]();
        }
    }
}


